import { NgModule } from '@angular/core';
import { LoadingBarComponent } from '../components/loading-bar/loading-bar.component';
import { StlrDialogModule } from '@tc/interstellar-dialog';
import { StlrFormModule } from '@tc/interstellar-form';
import { StlrNotificationModule } from '@tc/interstellar-notification';
import { StlrLayoutModule } from '@tc/interstellar-layout';
import { StlrIconModule } from '@tc/interstellar-icon';
import { StlrToasterModule } from '@tc/interstellar-toaster';

const modules = [StlrLayoutModule, StlrDialogModule, StlrFormModule, StlrNotificationModule, StlrIconModule, StlrToasterModule];

@NgModule({
    imports: [...modules, LoadingBarComponent],
    exports: [...modules, LoadingBarComponent],
})
export class StellarModule {}
